import { useEffect, useState } from "react";

const useClickOutsideHandler = (elemRef) => {
  const [handleActive, setHandleActive] = useState(false);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
  }, []);

  const handleClickOutside = (event) => {
    if (
      elemRef.current &&
      !elemRef.current.contains(event.target) &&
      elemRef.current.getAttribute("aria-expanded") === "false"
    )
      setHandleActive(false);
    else setHandleActive(true);
  };

  return { handleActive };
};

export default useClickOutsideHandler;
